import {
  assistantBudgetQueryOptions,
  assistantConversationsQueryOptions,
  assistantHealthQueryOptions,
} from "../../api/assistant";
import { prefetch as prefetchQuery } from "../../api/prefetch";
import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { AssistantLandingPage } from "./AssistantLandingPage";
import { AssistantStartPage } from "./AssistantStartPage";
import { AssistantPage } from "./AssistantPage";

export const route: NavigationItemType["route"] = {
  path: "assistant",
  children: [
    { index: true, element: <AssistantLandingPage /> },
    { path: "new", element: <AssistantStartPage /> },
    { path: ":conversationId", element: <AssistantPage /> },
  ],
};
export const to = (paths: Paths) => paths.assistant();

export const prefetch = () => {
  void prefetchQuery(assistantConversationsQueryOptions());
  void prefetchQuery(assistantBudgetQueryOptions());
  void prefetchQuery(assistantHealthQueryOptions());
};
